import { useCallback, useEffect, useRef, useState } from 'react';
import ReadingAudioPlayer from '../services/ReadingAudioPlayer';

export default function useReadingAudio(cardId, contentKey = '') {
  const [engine, setEngine] = useState(null);
  const [state, setState] = useState({ status: 'idle', units: [], index: -1, currentTime: 0, duration: 0 });
  const current = useRef(null);
  const getEngine = useCallback((id, key = '') => {
    if (current.current?.engine.cardId === id && current.current?.key === key) return current.current.engine;
    current.current?.unsubscribe(); current.current?.engine.dispose(); current.current = null;
    if (!id) { setEngine(null); return null; }
    const next = new ReadingAudioPlayer(id);
    current.current = { engine: next, key, unsubscribe: next.subscribe(setState) };
    setEngine(next); setState(next.state); return next;
  }, []);
  useEffect(() => { getEngine(cardId, contentKey); }, [cardId, contentKey, getEngine]);
  useEffect(() => () => { current.current?.unsubscribe(); current.current?.engine.dispose(); current.current = null; }, []);
  return { engine, state, getEngine };
}
